
/* Scale Speed — Shopify Cart Error Monitor v1 */
(function () {
  if (window.__ssCartMonitorInstalled) return;
  window.__ssCartMonitorInstalled = true;

  function endpointFor(url) {
    try {
      const u = new URL(url, location.href);
      if (u.origin !== location.origin) return null;

      const match = u.pathname.match(
        /\/cart\/(add|change|update|clear)(?:\.js)?$/
      );
      return match ? match[1] : null;
    } catch (_) {
      return null;
    }
  }

  function actionFor(endpoint, body) {
    if (endpoint === 'add') return 'add';
    if (endpoint === 'clear') return 'clear';

    let data;

    try {
      if (body instanceof FormData ||
          body instanceof URLSearchParams) {
        data = Object.fromEntries(body.entries());
      } else if (typeof body === 'string') {
        try {
          data = JSON.parse(body);
        } catch (_) {
          data = Object.fromEntries(
            new URLSearchParams(body).entries()
          );
        }
      }
    } catch (_) {}

    if (data) {
      if (data.quantity !== undefined &&
          Number(data.quantity) === 0) {
        return 'remove';
      }

      if (data.updates &&
          typeof data.updates === 'object' &&
          Object.values(data.updates).some(
            value => Number(value) === 0
          )) {
        return 'remove';
      }
    }

    return 'quantity_change_or_unknown';
  }

  function descriptionFrom(value) {
    try {
      const data = typeof value === 'string'
        ? JSON.parse(value)
        : value;

      const message =
        data?.description ||
        data?.message ||
        (typeof data?.errors === 'string'
          ? data.errors
          : null);

      return typeof message === 'string'
        ? message.slice(0, 200)
        : 'No error description';
    } catch (_) {
      return 'No error description';
    }
  }

  function report(endpoint, action, status, description) {
    try {
      if (!window.Sentry?.captureEvent) return;

      const ua = navigator.userAgent;
      let browser = 'other';

      if (/Android/i.test(ua)) {
        browser = /Firefox/i.test(ua)
          ? 'Android Firefox'
          : /Chrome/i.test(ua)
            ? 'Android Chrome'
            : 'Android other';
      } else if (/Chrome/i.test(ua)) {
        browser = 'Desktop Chrome';
      } else if (/Firefox/i.test(ua)) {
        browser = 'Desktop Firefox';
      } else if (/iPhone|iPad/i.test(ua)) {
        browser = 'iOS';
      }

      Sentry.captureEvent({
        message: 'Scale Speed Shopify cart API failure',
        level: 'error',
        fingerprint: [
          'ss-cart',
          endpoint,
          action,
          String(status)
        ],
        tags: {
          endpoint: endpoint,
          action: action,
          http_status: String(status),
          browser: browser,
          interface: /\/cart\/?$/.test(location.pathname)
            ? 'cart_page'
            : 'other_page'
        },
        extra: {
          error_description: description
        }
      });
    } catch (_) {
      // Monitoring must never interrupt shopping.
    }
  }

  // Observe fetch() requests without altering results.
  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      let endpoint = null;
      let action = 'unknown';

      try {
        const input = args[0];
        const url = input instanceof Request
          ? input.url
          : String(input);

        endpoint = endpointFor(url);

        if (endpoint) {
          action = actionFor(endpoint, args[1]?.body);
        }
      } catch (_) {}

      return originalFetch.apply(this, args).then(
        response => {
          if (endpoint && !response.ok) {
            try {
              response.clone().text().then(text => {
                report(
                  endpoint,
                  action,
                  response.status,
                  descriptionFrom(text)
                );
              }).catch(() => {
                report(endpoint, action, response.status,
                  'Response unreadable');
              });
            } catch (_) {
              report(endpoint, action, response.status,
                'Response unreadable');
            }
          }
          return response;
        },
error => {
  throw error;
}
      );
    };
  }

  // Also observe XMLHttpRequest (used by some themes/apps).
  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ssCartEndpoint = endpointFor(url);
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      const endpoint = this.__ssCartEndpoint;

      if (endpoint) {
        const action = actionFor(endpoint, body);

        this.addEventListener('loadend', function () {
          if (this.status < 400) return;

          let description = 'Network failure';

          try {
            if (this.status !== 0) {
              const value = this.responseType === 'json'
                ? this.response
                : this.responseText;
              description = descriptionFrom(value);
            }
          } catch (_) {
            description = 'Response unreadable';
          }

          report(endpoint, action, this.status, description);
        }, { once: true });
      }

      return originalSend.apply(this, arguments);
    };
  }
})();
